import React from "react";
import { configError } from "../lib/supabase";
import { LockupStacked } from "../components/Logo";

/**
 * Shown when the app built without its Supabase settings. Far more useful
 * than a white page — it tells you which variable is missing and where it
 * needs to go.
 */
export default function SetupNeeded() {
  return (
    <div className="centre">
      <div className="centre-box">
        <LockupStacked h={50} />
        <h1>Not connected</h1>
        <p>
          The app built, but without the settings it needs to reach the
          database. Nothing is broken — a value is just missing.
        </p>

        <div className="notice notice-error" style={{ marginBottom: "1.1rem" }}>
          {configError}
        </div>

        <p style={{ marginBottom: ".6rem" }}><strong>To fix it</strong></p>
        <ol className="muted" style={{ fontSize: ".875rem", lineHeight: 1.7,
                                       paddingLeft: "1.1rem", margin: "0 0 1.2rem" }}>
          <li>
            In Supabase: <strong>Settings → API Keys</strong>, copy the
            Project URL and the key starting <code>sb_publishable_</code>.
          </li>
          <li>
            In GitHub: <strong>Settings → Secrets and variables → Actions</strong>,
            add <code>VITE_SUPABASE_URL</code> and{" "}
            <code>VITE_SUPABASE_PUBLISHABLE_KEY</code>.
          </li>
          <li>
            In the <strong>Actions</strong> tab, re-run the deploy workflow.
            The values are baked in when the site is built, so adding them
            afterwards does nothing until you rebuild.
          </li>
        </ol>

        <p className="muted" style={{ fontSize: ".75rem" }}>
          Running locally? The same two values go in <code>.env.local</code>,
          then restart <code>npm run dev</code>.
        </p>

        <p className="muted" style={{ fontSize: ".6875rem", marginTop: "1.5rem",
                                      letterSpacing: ".08em", textTransform: "uppercase" }}>
          build {typeof __BUILD__ !== "undefined" ? __BUILD__ : "unknown"}
        </p>
      </div>
    </div>
  );
}
